import React, { useState, useEffect, PropTypes } from "react"
import { useMatch } from "@reach/router"
import { Button, Container, Row, Form, Col } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import Homepage from "../components/Home/Banner/Banner";
import { useLocation } from "@reach/router";
import PlainHeader from "../components/Home/Banner/PlainHeader";
import NewsHeader from "../components/Home/Banner/NewsHeader";
import FormHeader from "../components/Home/Banner/FormHeader";
import VideosHeader from "../components/Home/Banner/VideosHeader";
import WhiteHeader from "../components/Home/Banner/WhiteHeader";
import StaticBanner from "../components/Home/Banner/StaticBanner";
import SplitHeader from "../components/Home/Banner/SplitHeader";
import StaticContent from "./Home/StaticContent/StaticContent";
import StaticContentContact from "./StaticContent/staticContentContact";
import noIndexPath from "./property-search/noindexpath";

import { LATEST_NEWS_PAGE_URL, MEET_THE_TEAM_PAGE_URL, VIDEOS_PAGE_URL } from "../components/common/site/constants";
import GetInTouch from "./GetInTouch/GetInTouch";
import StaticContactForm from "../components/forms/static-contact-form";

import Foundation from "../components/Home/Foundation/Foundation";
import LatestNews from "../components/Home/News/LatestNews";
import AllNews from "../components/Home/News/AllNews";
import NewsDetail from "../components/Home/News/NewsDetail";
import News from "../components/Home/News/News";
import Videos from "../components/Home/Videos/Videos";
import Counter from "../components/Home/Counter/Counter";
import SocialMedia from "../components/Home/Counter/SocialMedia";
import ServiceTiles from "../components/Home/ServiceTiles/ServiceTiles";
import ImageServiceCards from "../components/Home/ServiceCards/ImageServiceCards";
import ServiceCards from "../components/Home/ServiceCards/ServiceCards";
import Information from "../components/Home/Information/Information";
import InformationList from "../components/Home/Information/InformationList";
import Sidebar from "../components/Sidebar/Sidebar";
import OurStorySidebar from "../components/Sidebar/OurStorySidebar";
import CareerSidebar from "../components/Sidebar/CareerSidebar";
import ServiceSidebar from "../components/Sidebar/ServiceSidebar";
import PlayVideo from "./Play/custom-video";
import Map from "../components/map/google/single";
import TeamSlider from "../components/StaticComponent/OurTeam/OurTeam";
import Breadcrumb from "../components/Home/Breadcrumb/Breadcrumb";
import AreaGuides from "../components/collections/AreaGuides";
import Peoples from "../components/collections/Peoples";
import PeopleDetail from "../components/StaticComponent/Founder/Founder";
import StaticContact from "../components/Home/ContactUs/StaticContact";
import Milestones from "../components/Home/AboutUs/Milestones";
import OfficeListings from "../components/collections/OfficeListings";

import About from "../components/Home/AboutUs/About";
import AnimationBlock from "../components/Home/AboutUs/AnimationBlock";
import FeaturedProperties from "../components/Home/Properties/FeaturedProperties";
import Reviews from "../components/Home/Reviews/Reviews";
import GoogleReviews from "../components/PropertyDetails/GoogleReviews/GoogleReviews";
import Contact from "../components/Home/ContactUs/Contact";
import StaticPageSidebar from "../components/Sidebar/StaticPageSidebar";
import Hero from "../components/Hero/Hero";
import PageHeader from "../components/PageHeader/PageHeader";
import CurrentVacancies from "../components/CurrentVacancies/CurrentVacancies";
import MortgageCalc from "../components/calculators/mortgagecalc/";

const Modules = (props) => {
    const locationpath = useLocation();
    const currentPath = locationpath.pathname;
    const shouldnoIndex = noIndexPath.includes(currentPath);
    // const NewsCategory = useMatch(LATEST_NEWS_PAGE_URL.alias + "/:item/");
    // const NewsDetails = useMatch(LATEST_NEWS_PAGE_URL.alias + "/:item/:slug")
    const PeopleDetails = useMatch(MEET_THE_TEAM_PAGE_URL.alias + "/:slug/")
    const VideoCategory = useMatch(VIDEOS_PAGE_URL.alias + "/:item/");

    const [sidebar, setSidebar] = useState(false);
    const [renderComponent, setRenderComponent] = useState(true);
    let language = typeof window !== 'undefined' ? localStorage.getItem('language') : null
    
    useEffect(() => {

        window.addEventListener("scroll", () => {
            setSidebar(window.scrollY > 0)

        })

        window.addEventListener("mousemove", () => {
            if (renderComponent === false) {
                setRenderComponent(true)
            }
        })
        window.addEventListener("keypress", () => {
            if (renderComponent === false) {
                setRenderComponent(true)
            }
        })
        window.addEventListener("touchmove", () => {
            if (renderComponent === false) {
                setRenderComponent(true)
            }
        })

        if (props.page.Pagename !== "Home") {
            setRenderComponent(true)
        }
    }, [])
    // if (NewsDetails !== null) {
    //     var URL = NewsDetails.slug
    //     var MAIN_URL = NewsDetails.item
    //     return (
    //         <div className={language === 'Russian' ? "russian-page-modules page-modules" : "page-modules"}>               
    //             <Breadcrumb data={{Label: 'Blogs',Main_Parent: { Label: 'News & Insights', id: "609cb72bf0c22758e21cd02e",URL: 'property-news' }, Sub_Parent: null}} page={props.page.Pagename} tag="details" category={MAIN_URL} name={URL}  />
    //             <NewsDetail detailpage={URL} alias={LATEST_NEWS_PAGE_URL.alias} category={MAIN_URL} site={props.site} timings={props.site.Available_Timings} location={props.location}/>
    //         </div>
    //     )
    // }
    // else {
        return (
            <>
            {props.page.Pagename !== "Home" &&
                <Breadcrumb data={props.page.all_menus ? props.page.all_menus[0] : ''} page={props.page.Pagename} />
            }
            <div className={language === 'Russian' ? "russian-page-modules page-modules" : "page-modules"}>
            <div className="section-page-header">
                {shouldnoIndex && <meta name="robots" content="noindex, nofollow" />}
            {props.page.Header_Style === "HeroBanner" ? (
                    <Hero
                        id={props.page._id}
                        imagetransforms={props.page.imagetransforms}
                        Title={props.page.Header_Title}
                        content={props.page.Header_Content}
                        image={props.page.Banner_Image}
                        info={props.page.Header_Contact_Info}
                        cta_1={props.page.Header_CTA_1_Label}
                        cta_2={props.page.Header_CTA_2_Label}
                        cta_1_link={props.page.Header_CTA_1_Link}
                        cta_2_link={props.page.Header_CTA_2_Link}
                        search={props.page.Show_Search_Type}
                        rating={props.page.Show_Google_Rating}
                        video={props.page.Video_URL}
                        mobile_sticky={props.page.Show_CTA_Sticky_Mobile}
                    />
                ) : props.page.Header_Style === "LandingPageHeader" ? (
                    <PageHeader
                        content={props.page.Header_Content}
                        title={props.page.Header_Title}
                        cta_1={props.page.Header_CTA_1_Label}
                        cta_2={props.page.Header_CTA_2_Label}
                        cta_1_link={props.page.Header_CTA_1_Link}
                        cta_2_link={props.page.Header_CTA_2_Link}
                        mobile_sticky={props.page.Show_CTA_Sticky_Mobile}
                    />
                ) : props.page.Header_Style === "White_Background" ? (
                    <WhiteHeader content={props.page.Header_Content} />
                ) : props.page.Header_Style === "SplitHeader" ? (
                    <SplitHeader
                        id={props.page._id}
                        imagetransforms={props.page.imagetransforms}
                        content={props.page.Header_Content}
                        image={props.page.Banner_Image}
                        info={props.page.Header_Contact_Info}
                        cta_1={props.page.Header_CTA_1_Label}
                        cta_2={props.page.Header_CTA_2_Label}
                        cta_1_link={props.page.Header_CTA_1_Link}
                        cta_2_link={props.page.Header_CTA_2_Link}
                        search={props.page.Show_Search_Type}
                        rating={props.page.Show_Google_Rating}
                        video={props.page.Video_URL}
                        title={props.page.Header_Title}
                        mobile_sticky={props.page.Show_CTA_Sticky_Mobile}
                    />
                ) : props.page.Banner_Image && props.page.Header_Style !== "NoBanner" ? (
                    <StaticBanner
                        id={props.page._id}
                        imagetransforms={props.page.imagetransforms}
                        content={props.page.Header_Content}
                        image={props.page.Banner_Image}
                        info={props.page.Header_Contact_Info}
                        cta_1={props.page.Header_CTA_1_Label}
                        cta_2={props.page.Header_CTA_2_Label}
                        cta_1_link={props.page.Header_CTA_1_Link}
                        cta_2_link={props.page.Header_CTA_2_Link}
                        search={props.page.Show_Search_Type}
                        rating={props.page.Show_Google_Rating}
                        video={props.page.Video_URL}
                        mobile_sticky={props.page.Show_CTA_Sticky_Mobile}
                        title={props.page.Header_Title}
                    />
                ) : props.page.Header_Style !== "NoBanner" ? (
                    <PlainHeader
                        content={props.page.Header_Content}
                        info={props.page.Header_Contact_Info}
                        cta_1={props.page.Header_CTA_1_Label}
                        cta_2={props.page.Header_CTA_2_Label}
                        cta_1_link={props.page.Header_CTA_1_Link}
                        cta_2_link={props.page.Header_CTA_2_Link}
                        search={props.page.Show_Search_Type}
                        rating={props.page.Show_Google_Rating}
                        video={props.page.Video_URL}
                        page={props.page.Pagename}
                        mobile_sticky={props.page.Show_CTA_Sticky_Mobile}
                    />
                ): ""
               }

                {/* {props.page.Layout === 'News_Landing' &&
                    <NewsHeader category={NewsCategory} />
                } */}

                {props.page.Header_Content && props.page.Banner_Image == null && props.page.Layout === 'Videos_Landing' && props.page.Header_Style !== "White_Background" &&
                    <VideosHeader content={props.page.Header_Content} category={VideoCategory} />
                }
                {props.page.Banner_Image && props.page.Layout === 'Forms_Landing' && props.page.Header_Style !== "White_Background" &&
                    <FormHeader id={props.page._id} imagetransforms={props.page.imagetransforms} image={props.page.Banner_Image} modules={props.page.Modules} />
                }

              </div>
                {(props.page.Layout === 'Static' || props.page.Layout === 'Service_Landing' || props.page.Layout === 'Our_Story_Landing' || props.page.Layout === 'Careers_Landing') && props.modules &&
                    <Container className={`static-content-landing ${props.page.Banner_Image === null ? 'no-banner sec-pdy-80 ss' : ''}`}>
                        <Row>
                            <div className={`col-xl-${props.page.Show_Sidebar ? '8' : '12'} col-lg-${props.page.Show_Sidebar ? '7' : '12'} plain-content`}>

                                {props.page.Banner_Image === null ? <div className="head-black">{HTMLReactParser(props.page.Header_Content.replace(/\n/g, '<br />'))}</div> : ''}

                                {props.modules && props.modules.map((module, i) => {
                                    return (
                                        <>
                                            {module.Add_Static_Content &&
                                                <StaticContent content= {module?.Add_Static_Content} ShowReadMoreMobile={module?.ShowReadMoreMobile}/>
                                            }
                                            {module.type === 'GLSTRAPI_ComponentModuleGetInTouch' &&
                                                <GetInTouch title={module?.text} phone={module?.Phone} email={module?.Email} />
                                            }
                                            {module.Video_Embed_URL && module.Video_Background_Image &&
                                                <div className="video">
                                                    <picture>
                                                        <img loading="lazy" className="bg-img" src={`${module.Video_Background_Image.url}`} alt={module.Video_Background_Image.alternativeText} />
                                                    </picture>
                                                    {module.Video_Embed_URL &&
                                                        <div className="banner-btn">
                                                            <PlayVideo url={module.Video_Embed_URL} />
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            
                                            {module.Select === 'Mortgage_Calculator' &&
                                                <div className="static-calc-block calculator-block">
                                                <div className="mortgage-calculator-block calculator-item sec-pdy-64">
                                                    <h4>Mortgage Calculator</h4>
                                                    <MortgageCalc propertyPrice={""} current={""}/>
                                                    </div>
                                                </div>       
                                            }
                                            {props.page.Pagename !== 'Sell your property with us' && module?.Service_Cards && module?.DisplayType === "FAQ" && props.page.Layout === 'Static' &&
                                                <ServiceCards data={module.Service_Cards} title={module?.SectionTitle} />
                                            }

                                        </>
                                    )
                                })}

                            </div>
                            {props.page.Show_Sidebar === true &&
                                <div className="col-xl-4 col-lg-5 col-md-12">
                                        {props.page.Layout === 'Static' && !props.page.Useful_Information &&
                                            <StaticPageSidebar
                                                class={`static-sticky-sidebar-widget`}
                                                peoples={props.page.Sidebar_Peoples}
                                                site={props.site}
                                                timings={props.site.Available_Timings}
                                                popular_search={props.page.Popular_Search}
                                                sidebarWidget={props.page.SidebarWidget}
                                            />
                                        }

                                    {props.page.Layout === 'Service_Landing' && props.page.Useful_Information === false &&
                                        <ServiceSidebar class={`${sidebar ? 'static-sticky-sidebar-widget' : ''}`} peoples={props.page.Sidebar_Peoples} site={props.site} timings={props.site.Available_Timings} />
                                    }
                                    {props.page.Layout === 'Service_Landing' && props.page.Useful_Information === true &&
                                        <Information />
                                    }
                                    {props.page.Layout === 'Our_Story_Landing' && props.page.Useful_Information === false &&
                                        <OurStorySidebar class={`static-sticky-sidebar-widget`} peoples={props.page.Sidebar_Peoples} site={props.site} timings={props.site.Available_Timings} popular_search={props.page.Popular_Search} sidebarWidget={props.page.SidebarWidget} />
                                    }
                                    {props.page.Layout === 'Careers_Landing' &&
                                        <CareerSidebar class={`static-sticky-sidebar-widget`} peoples={props.page.Sidebar_Peoples} site={props.site} timings={props.site.Available_Timings} popular_search={props.page.Popular_Search}
                                        sidebarWidget={props.page.SidebarWidget} />
                                    }
                                </div>
                            }
                        </Row>
                    </Container>
                }
                {
                    props.modules && props.modules.map((module, i) => {
                        return (
                            <>
                                {renderComponent && module.Place &&
                                    <FeaturedProperties place={module.Place} searchType={module.Search_Type} pagename={props.page.Pagename} />
                                }

                                {renderComponent && module.Add_Service &&
                                    <About service={module.Add_Service} id={props.page._id} imagetransforms={props.page.imagetransforms} ggfx_results={props?.page?.ggfx_results}/>

                                }
                                {module.Add_Service && props.page.Layout === 'Service_Landing' && props.page.Useful_Information === true &&
                                    <Container className={`static-content-landing pad-50`}>
                                        <Row>
                                            <div className={`col-xl-12  InformationList`}>
                                                <InformationList />
                                            </div>
                                        </Row>
                                    </Container>

                                }

                                {module.Animation &&
                                    <AnimationBlock {...module} />
                                }
                                {module.Select === 'Vision_Mission_Values' &&
                                    <Foundation />
                                }

                                {renderComponent && module.Select === 'Latest_News_and_Insights' &&
                                    <LatestNews />
                                }
                                {module.Select === 'Current_Vacancies' &&
                                   <CurrentVacancies />
                                }

                                {renderComponent && module.type === "GLSTRAPI_ComponentModuleFooterBlock" &&
                                    <Contact {...module} id={props.page._id} imagetransforms={props.page.imagetransforms} />
                                }
                                

                                {module.Select_Collection === 'Area_Guides' &&
                                    <AreaGuides />
                                }
                                {module.Select_Collection === 'Offices' &&
                                    <OfficeListings  />
                                }
                                
                                {module.Select_Collection === 'Reviews' &&
                                    <GoogleReviews />
                                }

                                {module.Select_Collection === 'Teams' &&
                                    <Peoples />
                                }

                                {/* {module.Select_Collection === 'News' && NewsCategory === null &&
                                    <AllNews />
                                }
                                {module.Select_Collection === 'News' && NewsCategory !== null &&
                                    <News slug={NewsCategory.item} />
                                } */}

                                {module.Select_Collection === 'Videos' &&
                                    <Videos category={VideoCategory} />
                                }

                                {module.type === 'GLSTRAPI_ComponentModuleMilestones' &&
                                    <Milestones {...module} />
                                }

                                {renderComponent && module.Reviews_Background_Image &&
                                    <Reviews image={module.Reviews_Background_Image} id={props.page._id} imagetransforms={props.page.imagetransforms} />
                                }

                                {renderComponent && module.Social_Media_Cards &&
                                    <SocialMedia stats={module.Social_Media_Cards} page={props.page.Pagename} />
                                }

                                {renderComponent && module.Add_Stat &&
                                    <Counter stats={module.Add_Stat} page={props.page.Pagename} />
                                }

                                {module.Add_Service_Tile &&
                                    <ServiceTiles data={module.Add_Service_Tile} title={module.Service_Block_Title} id={props.page._id} imagetransforms={props.page.imagetransforms} />
                                }
                                {module.Select_Peoples &&
                                    <TeamSlider intro={module.Teams_Intro_Content} data={module.Select_Peoples} layout={props.page.Layout} title={module?.Teams_Section_Title} />
                                }

                                {module.Latitude && module.Longtitude ?
                                    <Map lat={module.Latitude ? parseFloat(module.Latitude) : ''} lng={module.Longtitude ? parseFloat(module.Longtitude) : ''} height={"600px"} zoom={14} /> : ''}

                                {module?.Service_Cards && module?.DisplayType === "TileCard" &&
                                    <ImageServiceCards data={module.Service_Cards} id={props.page._id} imagetransforms={props.page.imagetransforms} />
                                }
                                {module?.Service_Cards && module?.DisplayType === "FAQ" && props.page.Pagename === 'Sell your property with us' && module?.Service_Cards && props.page.Layout === 'Static' &&
                                    <ServiceCards data={module.Service_Cards} title={module?.SectionTitle} />
                                }
                            </>
                        )
                    })
                }
            </div >
            
            </>
        )
    // }
}

export default Modules
